import React, { useState } from 'react'
import styles from './ModalAddServiceInstallation.module.css'
import PropTypes from 'prop-types'
import { t } from 'i18next'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import No from 'Assets/Images/Login/no.svg'
import drillIcon from 'Assets/Images/Generals/drill.svg'
import { NO_INSTALLATION_OPTION } from 'Utils/constants'
import { CustomDropdownSelector } from 'Components/ServiceCard/CustomDropdownSelector'
import { useInstallationServices } from 'Hooks/useInstallationServices'
import { addOrIncrementServiceInCart } from 'Utils/Helpers/cartInstallationHelpers'

const ModalAddServiceInstallation = ({
  show,
  onClose,
  services = [],
  installationService,
}) => {
  const dispatch = useDispatch()

  // Local state
  const [isApplying, setIsApplying] = useState(false)

  const {
    servicesData,
    selectedServices,
    rawSelected,
    selectService,
    removeService,
    cart,
    resetSelection,
  } = useInstallationServices(services, { syncWithCart: false })

  const handleApply = async () => {
    setIsApplying(true)
    for (const s of rawSelected) {
      await addOrIncrementServiceInCart(dispatch, cart, s)
    }

    resetSelection()
    setIsApplying(false)
    handleClose()
  }

  const handleToggleService = item => {
    const isAlreadySelected = rawSelected.some(
      s => s.productId === item.productId
    )

    if (isAlreadySelected) {
      removeService(item.productId)
    } else {
      selectService(item)
    }
  }

  const handleClose = () => {
    resetSelection()
    onClose()
  }

  const effectiveSelectedServices =
    selectedServices.length === 0 ? [NO_INSTALLATION_OPTION] : selectedServices

  return (
    <Modal
      centered
      show={show}
      backdrop="static"
      className={styles.modalAddServiceInstallation}>
      <div className={styles.modalContent}>
        <div className={styles.containerTitleService}>
          <button onClick={handleClose} className={styles.closeButton}>
            <img src={No} alt="close" />
          </button>
          <img
            src={drillIcon}
            alt="installation icon"
            className={styles.iconServiceInstallation}
          />
          <h3 className={styles.titleService}>
            {t('INSTALLATION_SERVICE_T.INSTALLATION_SERVICE')}
          </h3>
        </div>
        <div className={styles.serviceDetailsContainer}>
          <p className={styles.serviceDetails}>
            {t('INSTALLATION_SERVICE_T.INSTALLATION_SERVICE_DESCRIPTION', {
              sku: installationService?.productSku,
            })}
          </p>
          <CustomDropdownSelector
            label={NO_INSTALLATION_OPTION.name}
            value={effectiveSelectedServices}
            options={servicesData}
            onSelect={handleToggleService}
            getOptionLabel={item => item.name}
            getOptionValue={item => item.productId}
            name="services-selector"
            unselectableOption={NO_INSTALLATION_OPTION}
          />
          <div className={styles.buttonContainer}>
            <button className={styles.cancelButton} onClick={handleClose}>
              {t('Cancel')}
            </button>
            <button className={styles.applyButton} onClick={handleApply}>
              {isApplying ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                t('Apply')
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAddServiceInstallation

ModalAddServiceInstallation.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
  installationService: PropTypes.object,
}
